import React, { memo } from "react";

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { ReadOnlyIcon } from "modules/icons";
import ModalTitle from "./modal-title";
import { useOverlay } from "modules/providers/overlay-provider";
import colors from "app/colors";

const ReadOnlyThreadsInfoModal = () => {
  const { closeModal } = useOverlay();

  return (
    <Modal isOpen onClose={closeModal} size="sm" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalBody p={6}>
          <VStack textAlign="center" spacing={4}>
            <ModalTitle
              text="Read-Only Setting"
              icon={<ReadOnlyIcon boxSize={16} fill={colors.blackSecondary} />}
            />
            <Text fontSize={14} fontWeight={500} color={colors.gray50}>
              When this setting is toggled on, only the user who enabled it will
              be able to post messages in the thread. Only that user can remove
              the setting to allow everyone in the thread to post messages.
            </Text>
            <HStack>
              <Button height={8} px={10} onClick={closeModal}>
                Got it!
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(ReadOnlyThreadsInfoModal);
